import { useDebounce } from '@library/hooks/useDebounce';
import { useGetAddressAutocompleteQuery } from '@bo-services/addressAutocompleteApi';
import { useMemo } from 'react';

export interface AddressAutocompleteInputProps {
  latitude?: number;
  longitude?: number;
  value: string;
}

export const useAddressAutocomplete = ({
  latitude = 0,
  longitude = 0,
  value
}: AddressAutocompleteInputProps) => {
  const debouncedValue = useDebounce<string>({
    value,
    delay: 500
  });

  const { data: response } = useGetAddressAutocompleteQuery(
    {
      query: debouncedValue,
      latitude,
      longitude
    },
    {
      skip: !debouncedValue || debouncedValue.length < 3
    }
  );

  const validAddresses = useMemo(
    () =>
      response?.data.filter(
        (address) =>
          !!address.attributes.street && !!address.attributes.formatted_address
      ) ?? [],
    [response]
  );

  return {
    validAddresses
  };
};
